<h1 mat-dialog-title class="text-center">Resultados:</h1>
<div mat-dialog-content style="height: 550px;overflow: auto;">
  <div id="contentPDF">

  </div>
</div>
<div mat-dialog-actions class="d-flex justify-content-center">
  <button mat-raised-button color="primary" type="button" (click)="enviarPDF()" class="">Enviar PDF</button>
  <button mat-raised-button color="secondary" type="button" (click)="onNoClick()">Cancelar</button>
</div>
